import type { GuidelineViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';

export function toGuidelineViewModel(item: GuidelineViewModel): GuidelineViewModel {
  return Object.assign({}, item, { name: translateTemplateName(item.name) });
}
